/* ========== 対象処理 ========== */
// ポイント利用
// 1. 保持ポイント表示
// 2. ポイント数チェック
// 3. ポイント利用
// 4. ポイント削除
// 5. ギフトボックスのステータス処理（初回のみ）

document.addEventListener("DOMContentLoaded", function () {
  const canUsePoint = document.querySelector('.cart.section');

  // カートページ
  if (canUsePoint) {
    // ポイント表示
    setPoint();
    //ギフト選択処理
    const giftWrappingStatus = JSON.parse(document.getElementById('giftWrappingStatus').innerHTML);
    document.getElementById('cart-price__giftwrap').checked = (giftWrappingStatus == "あり") ? true:false;
  }
});

/**
 * カートページポイント表示
 *
 */
const setPoint = async () => {
  const customer = await getCustomer();

  if (!customer) {
    return;
  }

  setPointFields(customer);
};

/**
 * ポイント使用欄とモーダルに現保有ポイントを設定
 *
 * @param {*} customer
 */
const setPointFields = (customer) => {
  const availablePoints = customer.pointBalance ?? 0;
  let useInput = document.querySelector('.js-usepoint');
  let canUsePoint = document.querySelector('.js-usablepoint');
  let usePoint = document.querySelector('.p-cart-pointmodal__point span');

  if (canUsePoint) {
    canUsePoint.innerText = availablePoints.toLocaleString();
    canUsePoint.dataset.value = availablePoints;
  }

  usePoint.innerText = availablePoints.toLocaleString();
  useInput.max = Math.floor(availablePoints / 100) * 100;
};

/**
 * ポイント使用欄とモーダルに現保有ポイントを設定
 *
 */
const isUsingPoint = () => {
  const pointEle = document.querySelector('.js-usepoint-text');
  const point = Number(pointEle.dataset.id);

  return point > 0;
};

/**
 * ポイント用ディスカウントを削除する
 *
 * @param {string} pointCode
 */
const deletePoint = async (pointCode) => {
  const url = `${APP_PROXY_URL}/api/points/check`;
  const params = {
    pointCode
  };

  const res = await fetchPostMethod(url, params);

  if (res.message === 'ok') {
    if (!res.canUsePoint) {
      return 'ポイント残高が不足しています';
    }
    return '';
  } else {
    return res.message;
  }
};

/**
 * ポイント用ディスカウントを削除する
 *
 */
const checkUsingPoint = () => {
  const points = document.querySelector('.js-usepoint-text');

  if (Number(points.dataset.value) === 0) {
    return false;
  }

  return true;
};

(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const usePoint = document.getElementById('cart-price__usepoint');
    usePoint.addEventListener('change', (e) => {
      if (!e.target.checked) {
        const discountCode = (document.getElementById('_discount_code')) ? document.getElementById('_discount_code').value:null;
        if (discountCode) {
          cancelDiscountCode(discountCode);
        }
      }
    })


    const el = document.querySelector('#cart');
    el.addEventListener('submit', async function (e) {
      //カートボタン
      const checkoutBtn = document.getElementById('checkout')
      checkoutBtn.classList.add('loading');
      checkoutBtn.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      
      //ギフトラッピング処理
      const giftWrapInput= document.getElementById('cart-price__giftwrap__input')
      giftWrapInput.value = (document.getElementById('cart-price__giftwrap').checked) ? "あり":"なし";
      const cartSubmitInput = document.createElement('input');
      cartSubmitInput.setAttribute('name', 'checkout');
      cartSubmitInput.setAttribute('type', 'hidden');
      document.querySelector('#cart').appendChild(cartSubmitInput);

      if(checkoutBtn.classList.contains('not_login_user')){
        const discountCode = (document.getElementById('_discount_code')) ? document.getElementById('_discount_code').value:null;
        document.getElementById('_useing_point').value = ""
        document.getElementById('_discount_code').value = ""
        //ディスカウントコードがある場合
        if (discountCode) {
          e.preventDefault()
          const res = await cancelDiscountCode(discountCode);
          this.action = `/checkout/`
          this.submit()
        }
      }else if(document.getElementById('cart-price__usepoint').checked){
        e.preventDefault()
        // wl20230302
        if (document.querySelector('.pointmodal__usepoint').value == "" && document.getElementById('_useing_point').value != "") {
          document.querySelector('.pointmodal__usepoint').value = document.getElementById('_useing_point').value
          // もし既にあるディスカウントを削除する場合
          // const discountCode = (document.getElementById('_discount_code')) ? document.getElementById('_discount_code').value:null;
          // //ディスカウントコードがある場合
          // if (discountCode) {
          //   e.preventDefault()
          //   const res = await cancelDiscountCode(discountCode);
          // }
        }
        const res = await createDiscountCode();
        if(res.message === 'ok'){
          if (document.documentElement.lang === 'en') {
            this.action = `/en/cart/?discount=${res.discount.code}`
          } else if (document.documentElement.lang === 'zh-Hans') {
            this.action = `/zh/cart/?discount=${res.discount.code}`
          } else {
            this.action = `/cart/?discount=${res.discount.code}`
          }
          document.getElementById('_useing_point').value = document.querySelector('.pointmodal__usepoint').value
          document.getElementById('_discount_code').value = res.discount.code
          this.submit()
        }
        else {
          checkoutBtn.classList.remove('loading');
          checkoutBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
          alert('ポイントの利用に失敗しました。ポイントをご利用される場合は、\n時間を空けて再度お試しください。');
        }
        return false
      }
      // wl20230302
      //check:off
      else {
        const discountCode = (document.getElementById('_discount_code')) ? document.getElementById('_discount_code').value:null;
        document.getElementById('_useing_point').value = ""
        document.getElementById('_discount_code').value = ""
        //ディスカウントコードがある場合
        if (discountCode) {
          e.preventDefault()
          const res = await cancelDiscountCode(discountCode);
          this.action = `/checkout/`
          this.submit()
        }
      }
    })  
  })
}())

/**
 * ディスカウントコード発行
 *
 */
const createDiscountCode = async () => {
  const url = `${APP_PROXY_URL}/api/points/use`;
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';

  const point = document.querySelector('.pointmodal__usepoint');
  const params = validateUsePoint(point);
  if (!params) {
    return;
  }

  return await fetchPostMethod(url, params);

  // console.log('res',res);
  // if (res.message === 'ok') {
  //   const usePoint = document.getElementById('_useing_point')
  //   let discountCode = document.getElementById('_discount_code');

  //   usePoint.value = point.value;
  //   discountCode.value = res.discount.code;

  //   window.open(`https://${location.hostname}/discount/${res.discount.code}`);
  // } else {
  //   errorMessage.innerText = res.message;
  // }
};

// wl20230302
/**
 * ディスカウントコード削除
 *
 */
const cancelDiscountCode = async (discountCode) => {
  if (!discountCode) {
    return;
  }
  const url = `${APP_PROXY_URL}/api/points/cancel`;
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';

  const params = {pointCode: discountCode};
  if (!params) {
    return;
  }

  return await fetchPostMethod(url, params);
};
